var render = function (_h,_vm) {var _c=_vm._c;return _c('span',{staticClass:"count-item",class:_vm.props.classes.concat( [{rounded: _vm.props.rounded}]),attrs:{"data-test":_vm.props.dataTest}},[(!_vm.props.hideTooltip)?_c('v-tooltip',{attrs:{"right":true},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('div',_vm._g({staticClass:"full-width"},on),[_vm._t("default")],2)]}}],null,true)},[_c('span',[_vm._v(_vm._s(_vm.props.tooltip))])]):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }